import ScrollLinksHandler from "../../../../../Private/Fusion/Presentation/Atom/ScrollLink/ScrollLink";

export default class Forms {
	static init() {
		setTimeout(function () {
			ScrollLinksHandler.scrollToElement(document.querySelector('.form--has-errors, #form-success-message'), -30);
		}, 100);

        // Add a single event listener to the document for 'invalid' events during the capturing phase
        document.addEventListener(
            'invalid',
            (event) => {
                if (event.target.closest('form.form')) {
                    event.target.classList.add('was-validated');
                }
            },
            true // Use the capturing phase since 'invalid' events don't bubble
        );

        Forms.initSolutionDropdownToggle();
        Forms.initFileUploads();
	}

	// Replaces the browser's file button and names a limit only once a selection breaks it.
	static initFileUploads() {
		document.querySelectorAll('[data-file-upload]').forEach((container) => {
			const input = container.querySelector('input[type="file"]');
			const list = container.querySelector('[data-file-upload-list]');
			const listWrapper = container.querySelector('[data-file-upload-list-wrapper]');
			const errors = container.querySelector('[data-file-upload-errors]');
			if (!input || !list || !listWrapper || !errors) {
				return;
			}

			const data = container.dataset;
			const maximumCount = parseInt(data.maximumCount, 10);
			const maximumFileBytes = parseInt(data.maximumFileBytes, 10);
			const maximumTotalBytes = parseInt(data.maximumTotalBytes, 10);
			const allowedExtensions = (data.allowedExtensions || '')
				.split(',')
				.map((extension) => extension.trim().toLowerCase())
				.filter(Boolean);

			const validate = (files) => {
				if (files.length > maximumCount) {
					return data.messageCount;
				}
				let totalBytes = 0;
				for (const file of files) {
					const dot = file.name.lastIndexOf('.');
					const extension = dot === -1 ? '' : file.name.slice(dot + 1).toLowerCase();
					if (!allowedExtensions.includes(extension)) {
						return /^[a-z0-9]{1,16}$/.test(extension)
							? data.messageType.replace('%ext%', extension.toUpperCase())
							: data.messageTypeUnknown;
					}
					if (file.size > maximumFileBytes) {
						return data.messageFileSize;
					}
					totalBytes += file.size;
				}
				return totalBytes > maximumTotalBytes ? data.messageTotalSize : '';
			};

			const render = () => {
				const files = Array.from(input.files || []);
				list.replaceChildren(...files.map((file) => {
					const item = document.createElement('li');
					item.textContent = file.name;
					return item;
				}));
				listWrapper.hidden = files.length === 0;

				const message = validate(files);
				input.setCustomValidity(message);
				errors.replaceChildren();
				errors.hidden = message === '';
				if (message) {
					const item = document.createElement('li');
					const text = document.createElement('span');
					text.className = 'neos-help-block';
					text.textContent = message;
					item.append(text);
					errors.append(item);
				}
			};

			input.addEventListener('change', () => {
				// A new selection makes the server's verdict about the previous one obsolete.
				const group = container.closest('.form-group');
				if (group) {
					group.classList.remove('error');
					group.querySelectorAll(':scope > .errors').forEach((serverErrors) => serverErrors.remove());
				}
				const reselect = container.querySelector('[data-file-upload-reselect]');
				if (reselect) {
					reselect.remove();
				}
				render();
			});
			render();
		});
	}

	static initSolutionDropdownToggle() {
		const solutionGroup = document.querySelector('.form-group--solution-dropdown-group');
		if (!solutionGroup) {
			return;
		}
		const triggerValues = (solutionGroup.dataset.solutionTriggerValues || '').split(',').map(v => v.trim()).filter(Boolean);
		if (triggerValues.length === 0) {
			return;
		}
		const inquirySelect = document.getElementById('inquiry');
		const solutionSelect = solutionGroup.querySelector('select');
		if (!inquirySelect || !solutionSelect) {
			return;
		}
		function toggleSolutionDropdown() {
			const selected = inquirySelect.value || '';
			const show = triggerValues.includes(selected);
			solutionGroup.style.display = show ? '' : 'none';
			if (solutionSelect) {
				if (show) {
					solutionSelect.required = true;
				} else {
					solutionSelect.value = '';
					solutionSelect.required = false;
				}
			}
		}
		inquirySelect.addEventListener('change', toggleSolutionDropdown);
		toggleSolutionDropdown();
	}
}
